/**
 * Le due figure della conversazione (`data-variant` della voce): chi ha segnalato a sinistra, il
 * supporto a destra, con il fondo della bolla. Il contrasto del testo su entrambi i fondi è
 * verificato in `ThreadMessage.test.tsx` (almeno 4.5:1).
 */
export const MESSAGE_BUBBLES = {
  utente: { side: 'flex-start', bgcolor: 'grey.100' },
  supporto: { side: 'flex-end', bgcolor: 'primary.lighter' },
} as const;
